import { parseNumber } from '../../utils/number.utils';
import { SaleOrderControlDocument } from '../sale-order-control-document';

export class SaleOrderControlDocumentBuilder {

  static fromJson(json): SaleOrderControlDocument {
    return (json) ? new SaleOrderControlDocument(
        json.hash,
        json.saleOrderHash,
        parseNumber(json.date),
        json.transportOperator,
        json.carrier,
        json.enrollment,
        json.trailer,
        json.observation,
        json.viewLogoInPdf,
        json.packingUnits
    ) : null;
  }
}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/ubaristi-app-test/workspace/src/app/core/models/builders/sale-order-control-document-builder.ts